import { useQuery } from "@tanstack/react-query";

import { getPilotInsights } from "@/api/insights";

export function useInsightsQuery() {
  return useQuery({
    queryKey: ["insights", "pilot"],
    queryFn: getPilotInsights,
    staleTime: 60_000,
  });
}
